import {DocumentoPac} from "./DocumentoPac";

export class ColecaoPac {

  list: DocumentoPac[];

}
